<p>
    @switch (textType) {
        @case (types.TIP) {
            <div class="green-bold-text">{{ 'global.tip.title' | apContent }}</div>
        }
        @case (types.INFO) {
            <div class="green-bold-text">{{ 'global.info.title' | apContent }}</div>
        }
    }
    {{ tipContent }}

    @if (textType === types.TIP) {
        <div class="ap-margin-top-3">
            <ap-button [text]="true" ariaLabel="Tip summary" (click)="openModal()"
                >{{ 'global.tip.summary' | apContent
                }}<ap-icon color="secondary" name="arrow-right" size="medium" class="ap-margin-left-1"></ap-icon>
            </ap-button>
        </div>
    }
</p>
